const incomeStat = {
  state: {
    searchQuery: {
      parkingId: '',
      dateRange: []
    }
  },

  mutations: {
    SET_SEARCH_QUERY: (state, data) => {
      state.searchQuery = data
    }

  },

  actions: {
    getSearchQuery({ commit }, data) {
      commit('SET_SEARCH_QUERY', data)
    }

  },
  getters: {
    getSearchQuery: state => state.searchQuery
  }
}

export default incomeStat
